module.exports = __webpack_public_path__ + "img/startnow@2x.21d816c.jpg";